import Typography from 'components/Typography';
import { htmlId } from 'utils/html';

import { getContent } from './AvatarUpdate.content';
import { StyledAvatarUpdateWrapper } from './AvatarUpdate.styles';
import { AvatarUpdateComponentProps } from './AvatarUpdate.types';

const AvatarUpdate = ({ name, activityState, extensionUniqueKey }: AvatarUpdateComponentProps) => {
  const displayText = getContent(name, activityState);

  if (!displayText) return null;

  return (
    <StyledAvatarUpdateWrapper id={htmlId(`message-extension-avatarUpdate-${extensionUniqueKey}`)}>
      <Typography as='h4' color='default' variant='label' size='md'>
        {displayText}
      </Typography>
    </StyledAvatarUpdateWrapper>
  );
};

export default AvatarUpdate;
